import { ENV_TYPE } from '../../../lib/constants'
import * as pxp from '../lib/pxp'

const omittedFlows = [ENV_TYPE.DONATE, ENV_TYPE.POOLS]

export function isV2API(env) {
  if (omittedFlows.includes(env)) {
    return false
  }

  return pxp && pxp.isTreatment('Trmt_p2p_v2_integration_1')
}

// This is a new experiment for Phase Two V2 Work. By the time this ramped, phase one and the above experiemnt should be deleted
export function isV2PhaseTwo(env) {
  // TODO we need to address these flows

  if (omittedFlows.includes(env)) {
    return false
  }

  return (
    pxp &&
    pxp.isTreatment('Trmt_p2p_v2_integration_1') &&
    pxp.isTreatment('Trmt_p2p_v2_integration_phasetwo')
  )
}

export function isV2PricingReq(env) {
  if (omittedFlows.includes(env)) {
    return false
  }

  return (
    pxp &&
    pxp.isTreatment('Trmt_p2p_v2_integration_1') &&
    pxp.isTreatment('Trmt_p2p_v2_integration_phasetwo') &&
    pxp.isTreatment('Trmt_p2p_v2_calculate_exchange_rate')
  )
}
